import React, { Component } from 'react';
import './App.css';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.css';


class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      formData: {
        age: '',
        size: '',
        ext: '',
        num: '',
        sex: '1',
        race: '1',
        ru: '1',
        his: '1',
        grade: '1',
        stage: '0',
        surgery: '0',
        met: '0',
      },
      result: ""
    };
  }

  handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    var formData = this.state.formData;
    formData[name] = value;
    this.setState({
      formData
    });
  }

  handleSelectChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    var formData = this.state.formData;
    formData[name] = value;
    this.setState({
      formData
    });
  }

  handlePredictClick = (event) => {
    const formData = this.state.formData;
    this.setState({ result: "", isLoading: true });
/*
    this.setState({
          result: JSON.stringify(formData),
          isLoading: false
        });
*/

    Promise.race([
      fetch('https://flask.ljzxy.com/NET/',
      //fetch('http://127.0.0.1:5000/NET/',
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(formData)
      }),
      new Promise(function(resolve,reject){
        setTimeout(()=> reject(new Error('request timeout')),5000)
      })])
      .then(response => response.json())
      .then(response => {
        this.setState({
          result: response.result,
          isLoading: false
        });
      }).catch(()=>{
        this.setState({
          result: "Connection server timed out, please try again.",
          isLoading: false
        });
    });
  }

  handleCancelClick = (event) => {
    this.setState({ result: "" });
  }


  render() {
    const isLoading = this.state.isLoading;
    const formData = this.state.formData;
    const result = this.state.result;

    return (
      <Container>
        <div>
          <h1 className="title">Predicting Five-year Survival in R-NETs</h1>
        </div>
        <div className="content">
          <Form>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label className="label-head">General information</Form.Label>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Age (years)</Form.Label>
                <Form.Control 
                  type="number" 
                  placeholder="(years)" 
                  name="age"
                  value={formData.age}
                  onChange={this.handleChange} />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Sex</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.sex}
                  name="sex"
                  onChange={this.handleSelectChange}>
                  <option value={2}>Female</option>
                  <option value={1}>Male</option>
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Race</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.race}
                  name="race"
                  onChange={this.handleSelectChange}>
                  <option value={1}>White</option>
                  <option value={2}>Black</option>
                  <option value={3}>Other</option>
                  <option value={-1}>Unknown</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Rural or Urban</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.ru}
                  name="ru"
                  onChange={this.handleSelectChange}>
                  <option value={1}>Metropolitan(population over 1 million)</option>
                  <option value={2}>Medium-sized urban(population 250,000-1 million)</option>
                  <option value={3}>Small urban(population less than 250,000)</option>
                  <option value={4}>Rural close to urban</option>
                  <option value={5}>Rural not close to urban</option>
                  <option value={-1}>Unknown/Not sure</option>
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label className="label-head">Tumor information</Form.Label>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Histologic Type</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.his}
                  name="his"
                  onChange={this.handleSelectChange}>
                  <option value={1}>Carcinoid tumor</option>
                  <option value={2}>Neuroendicrine carcinoma</option>
                  <option value={3}>Atypical carcinoid tumor</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Grade</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.grade}
                  name="grade"
                  onChange={this.handleSelectChange}>
                  <option value={1}>Well differentiated</option>
                  <option value={2}>Moderately differentiated</option>
                  <option value={3}>Poorly differentiated</option>
                  <option value={4}>Undifferentiated</option>
                  <option value={-1}>Unknown</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Summary Stage</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.stage}
                  name="stage"
                  onChange={this.handleSelectChange}>
                  <option value={0}>In situ</option>
                  <option value={1}>Localized</option>
                  <option value={2}>Regional</option>
                  <option value={7}>Distant</option>
                  <option value={-1}>Unknown</option>
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Surgical Approach</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.surgery}
                  name="surgery"
                  onChange={this.handleSelectChange}>
                  <option value={0}>No surgery</option>
                  <option value={10}>Local tumor destruction</option>
                  <option value={20}>Local tumor excision</option>
                  <option value={30}>Wedge or segmental resection; partial proctectomy</option>
                  <option value={40}>Pull through WITH sphincter preservation (colo-anal anastomosis)</option>
                  <option value={50}>Total proctectomy</option>
                  <option value={60}>Total proctocolectomy</option>
                  <option value={70}>Proctectomy or proctocolectomy with resection in continuity with other organs; pelvic exenteration</option>
                  <option value={80}>Proctectomy</option>
                  <option value={90}>Uncertain surgery</option>
                  <option value={-1}>Unknown if surgery performed</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Tumor Size (mm)</Form.Label>
                <Form.Control 
                  type="number" 
                  placeholder="(mm)" 
                  name="size"
                  value={formData.size}
                  onChange={this.handleChange} />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Metastasis (Bone,Liver,Brain)</Form.Label>
                <Form.Control 
                  as="select"
                  value={formData.met}
                  name="met"
                  onChange={this.handleSelectChange}>
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                  <option value={-1}>Unknown</option>
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Farthest Extension of Tumors</Form.Label>
                <Form.Control 
                  type="number" 
                  placeholder="" 
                  name="ext"
                  value={formData.ext}
                  onChange={this.handleChange} />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Tumor Numbers</Form.Label>
                <Form.Control 
                  type="number" 
                  placeholder="" 
                  name="num"
                  value={formData.num}
                  onChange={this.handleChange} />
              </Form.Group>
            </Form.Row>
            {result === "" ? null :
              (<Row>
                <Col className="result-container">
                  <h5 id="result">{result}</h5>
                </Col>
              </Row>)
            }
            <Row>
              <Col>
                <Button
                  block
                  variant="success"
                  disabled={isLoading}
                  onClick={!isLoading ? this.handlePredictClick : null}>
                  { isLoading ? 'Making prediction' : 'Predict' }
                </Button>
              </Col>
              <Col>
                <Button
                  block
                  variant="danger"
                  disabled={isLoading}
                  onClick={this.handleCancelClick}>
                  Reset prediction
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>
    );
  }
}

export default App;
